const servicesSwiper = new Swiper('.logos-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 'auto',
    //slidesPerViewAutoSlideSize: 500,
    spaceBetween: 40,
    autoplay: true,
    allowTouchMove: true, // Enable touch/swipe gestures
    speed: 800,
    navigation: {
        nextEl: '.trustmarks .swiper-controls .next',
        //prevEl: '.sliding-cards .swiper-controls .prev',
    },
});